export default {
    STORE_USER(state, data) {
        state.user = data;
    },

    UPDATE_USER_AVATAR(state, data) {
        state.user.avatar = data;
    },
};
